import React from 'react';

const Root = ({ element }) => {
  return element || null;
};

export default Root;
